import React, { useContext, useEffect, useState } from 'react';
import DashboardCard from './components/DashboardCard';
import ChartMain from './components/ChartMain';
import { Link } from 'react-router-dom';
import { TransactionContext } from '../../context/TransactionProvider';
import { format, startOfWeek, lastDayOfWeek } from 'date-fns';
import { getIncome, getTodayBookings } from '../../api/sportaloka-client';
import Bookings from './components/Bookings';
import Reviews from './components/Reviews';

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [income, setIncome] = useState(0);
  const [incomes, setIncomes] = useState([]);
  const [bookings, setBookings] = useState(0);
  const [guests, setGuests] = useState([]);

  const {
    balance,
    loading: balanceLoading,
    error: balanceError,
    refreshBalance
  } = useContext(TransactionContext);

  const getData = async () => {
    try {
      const startDate = format(startOfWeek(new Date(), { weekStartsOn: 1 }), 'yyyy-MM-dd');
      const endDate = format(lastDayOfWeek(new Date(), { weekStartsOn: 1 }), 'yyyy-MM-dd');
      const query = new URLSearchParams({
        start_date: startDate,
        end_date: endDate
      }).toString();
      setLoading(true);
      const fetchIncome = await getIncome(query);
      const fetchBookings = await getTodayBookings(query);
      setBookings(fetchBookings.data.data.length);
      setGuests(fetchBookings.data.data.flatMap((curr) => curr.guests));
      setIncome(
        fetchIncome.data.data.reduce((acc, curr) => {
          return acc + curr.amount;
        }, 0)
      );
      setIncomes(fetchIncome.data.data);
      setError(false);
      setLoading(false);
    } catch (error) {
      console.log(error.message);
      setError(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <div className="row y-gap-20 justify-between items-end pb-60 lg:pb-40 md:pb-32">
      <div className="col-12">
        <h1 className="text-30 lh-14 fw-600">Dashboard</h1>

        <div className="row y-gap-30 mt-4">
          <div className="col-xl-3 col-md-6">
            <div className="py-30 px-30 rounded-4 bg-white shadow-3">
              <div className="row y-gap-20 justify-between items-center">
                <div className="col-auto">
                  <div className="fw-500 lh-14">Saldo</div>
                  <div className="text-20 lh-16 fw-600 mt-5">
                    {balanceLoading && !balanceError && 'Loading...'}
                    {!balanceLoading && balanceError && 'Gagal'}
                    {!balanceLoading && !balanceError && `${balance.toLocaleString()}`}
                  </div>
                  {!balanceError && (
                    <div className="text-15 lh-14 text-light-1 mt-5">Jumlah saat ini</div>
                  )}
                  {balanceError && (
                    <div
                      onClick={refreshBalance}
                      className="text-15 lh-14 text-light-1 mt-5 cursor-pointer text-danger fw-semibold">
                      Refresh
                    </div>
                  )}
                </div>
                <div className="col-auto">
                  <img src="/img/dashboard/icons/1.svg" alt="icon" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6">
            <div className="py-30 px-30 rounded-4 bg-white shadow-3">
              <div className="row y-gap-20 justify-between items-center">
                <div className="col-auto">
                  <div className="fw-500 lh-14">Pemasukan</div>
                  <div className="text-20 lh-16 fw-600 mt-5">
                    {loading && !error && 'Loading...'}
                    {!loading && error && 'Gagal'}
                    {!loading && !error && `${income.toLocaleString()}`}
                  </div>
                  {!error && (
                    <div className="text-15 lh-14 text-light-1 mt-5">Total minggu ini</div>
                  )}
                  {error && (
                    <div
                      onClick={getData}
                      className="text-15 lh-14 text-light-1 mt-5 cursor-pointer text-danger fw-semibold">
                      Refresh
                    </div>
                  )}
                </div>
                <div className="col-auto">
                  <img src="/img/dashboard/icons/2.svg" alt="icon" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6">
            <div className="py-30 px-30 rounded-4 bg-white shadow-3">
              <div className="row y-gap-20 justify-between items-center">
                <div className="col-auto">
                  <div className="fw-500 lh-14">Tamu</div>
                  <div className="text-20 lh-16 fw-600 mt-5">
                    {loading && !error && 'Loading...'}
                    {!loading && error && 'Gagal'}
                    {!loading && !error && guests.length}
                  </div>
                  {!error && <div className="text-15 lh-14 text-light-1 mt-5">Jumlah hari ini</div>}
                  {error && (
                    <div
                      onClick={getData}
                      className="text-15 lh-14 text-light-1 mt-5 cursor-pointer text-danger fw-semibold">
                      Refresh
                    </div>
                  )}
                </div>
                <div className="col-auto">
                  <img src="/img/dashboard/icons/4.svg" alt="icon" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6">
            <div className="py-30 px-30 rounded-4 bg-white shadow-3">
              <div className="row y-gap-20 justify-between items-center">
                <div className="col-auto">
                  <div className="fw-500 lh-14">Booking</div>
                  <div className="text-20 lh-16 fw-600 mt-5">
                    {loading && !error && 'Loading...'}
                    {!loading && error && 'Gagal'}
                    {!loading && !error && bookings}
                  </div>
                  {!error && <div className="text-15 lh-14 text-light-1 mt-5">Jumlah hari ini</div>}
                  {error && (
                    <div
                      onClick={getData}
                      className="text-15 lh-14 text-light-1 mt-5 cursor-pointer text-danger fw-semibold">
                      Refresh
                    </div>
                  )}
                </div>
                <div className="col-auto">
                  <img src="/img/dashboard/icons/3.svg" alt="icon" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row y-gap-30 pt-20 chart_responsive">
          <div className="col-12">
            <div className="py-30 px-30 rounded-4 bg-white shadow-3 h-100">
              <div className="d-flex justify-between items-center">
                <h2 className="text-18 lh-1 fw-500">Tamu Hari Ini</h2>
                <div>
                  <Link to="/bookings" className="text-14 text-blue-1 fw-500 underline">
                    Lihat Semua
                  </Link>
                </div>
              </div>
              {/* End d-flex */}

              <table className="table table-striped">
                <thead>
                  <th className="text-left px-2">Kode Booking</th>
                  <th className="text-left px-2">Nama Tamu</th>
                  <th className="text-left px-2">Nama Pemesan</th>
                  <th className="text-left px-2">Tanggal Pemesanan</th>
                  <th className="text-left px-2">Status</th>
                </thead>
                <tbody>
                  {guests.slice(0, 5).map((guest) => (
                    <tr key={guest.id}>
                      <td className="px-2">{guest.booking.booking_code}</td>
                      <td className="px-2">{guest.fullname}</td>
                      <td className="px-2">{guest.booking.user.fullname}</td>
                      <td className="px-2">
                        {format(new Date(guest.booking.booked_on_date), 'dd/MM/yyyy')}
                      </td>
                      <td className="px-2">{guest.booking.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* End py-30 */}
          </div>
          <div className="col-12 col-md-6">
            <div className="py-30 px-30 rounded-4 bg-white shadow-3 h-100">
              <div className="d-flex justify-between items-center">
                <h2 className="text-18 lh-1 fw-500">Persetujuan Pesanan</h2>
                <div>
                  <Link to="/bookings" className="text-14 text-blue-1 fw-500 underline">
                    Lihat Semua
                  </Link>
                </div>
              </div>
              {/* End d-flex */}
              <Bookings />
            </div>
            {/* End py-30 */}
          </div>

          <div className="col-12 col-md-6">
            <div className="py-30 px-30 rounded-4 bg-white shadow-3 h-100">
              <div className="d-flex justify-between items-center">
                <h2 className="text-18 lh-1 fw-500">Persetujuan Ulasan</h2>
                <div>
                  <Link to="/review" className="text-14 text-blue-1 fw-500 underline">
                    Lihat Semua
                  </Link>
                </div>
              </div>
              {/* End d-flex */}
              <Reviews />
            </div>
            {/* End py-30 */}
          </div>
          {/* End .col */}
          <div className="col-12">
            <div className="py-30 px-30 rounded-4 bg-white shadow-3 h-100">
              <div className="d-flex justify-between items-center">
                <h2 className="text-18 lh-1 fw-500">Grafik Pemasukan minggu ini</h2>
              </div>
              {/* End d-flex */}

              {loading && !error && <div className="mt-40 text-center fw-semibold">Loading...</div>}
              {!loading && error && (
                <div className="mt-40 text-center fw-semibold">
                  Gagal mendapatkan data{' '}
                  <span className="text-danger fw-bold cursor-pointer" onClick={getData}>
                    Coba kembali
                  </span>
                </div>
              )}
              {!loading && !error && <ChartMain incomes={incomes} />}
            </div>
            {/* End py-30 */}
          </div>
        </div>
      </div>
      {/* End .col-12 */}
    </div>
  );
};

export default Dashboard;
